














































import {Component, Vue} from "vue-property-decorator";
import {UserInfoUtils} from "@/model/user-info/functions/user-info-utils";
import UserInfoView from "@/component/mypage/user-info-view.vue";
import {CustomerUtils} from "@/customer-utils";
import {CUSTOMERS_MODEL_STATUS, CustomersModel} from "@/model/customer.model";
import CarInfoView from "@/component/mypage/car-info-view.vue";
import CustomerCodeView from "@/component/mypage/customer-code-view.vue";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";
import {StringUtils} from "@/string-utils";
import {Message} from "@/message";
import {DisplayUtils} from "@/display-utils";
import {CommonConstant} from "@/common-constant";
import {UserInfoForUpdateTmpModel} from "@/model/user-info/user-info-for-update-tmp.model";
import {GtmScript} from "@/router/gtm-script";

type SelectedPage = 'member-info' | 'car-info-view' | 'customer-code-view';
const pages: string[] = ['member-info' ,'car-info-view', 'customer-code-view']

@Component({
  components: {UserInfoView, CarInfoView, CustomerCodeView}
})
export default class MyPage extends Vue {
  /** 共通ID表示名 */
  commonIdName: string = CommonConstant.COMMON_ID_NAME;

  model:UserInfoForUpdateTmpModel = new UserInfoForUpdateTmpModel;
  customerModel:CustomersModel = new CustomersModel;
  redirectUrl:string;
  selectedPage:SelectedPage = 'member-info';

  /** メール再送のエラーメッセージ */
  errorMessage: string = "";

  /** スマポアプリからの遷移モード */
  isSmartphoneAppMode: boolean;

  created() {
    this.redirectUrl = sessionStorage.getItem("redirectUrl");

    if (StringUtils.toBool(sessionStorage.getItem("showCustomerCode"))) {
      // 顧客コード表示
      this.selectedPage = 'customer-code-view';
      sessionStorage.removeItem("showCustomerCode");
    }

    // selectedPageが設定されていた場合にページを選択する
    if(sessionStorage.getItem("selectedPage")) {
      // 選択ページを設定する（存在しない場合はマイページTOPを設定）
      this.selectedPage = this.checkSelectedPage(sessionStorage.getItem("selectedPage")) as SelectedPage
    }

    // 会員情報の取得
    UserInfoUtils.getUserInfo((status: number, userInfo: any) => {
      if (status == 200) {
        this.model.copy(userInfo);
      } else {
        this.$router.push("/client/error");
      }
    });

    // 顧客情報の取得
    CustomerUtils.getCustomers((status: number, customers: any) => {
      const newModel = new CustomersModel;
      if (status == 200) {
        newModel.customers = customers;
        newModel.status = CUSTOMERS_MODEL_STATUS.LOADED;
      } else {
        newModel.status = CUSTOMERS_MODEL_STATUS.ERROR;
      }
      this.customerModel = newModel;
    });

    // タイムアウトフラグが立っている場合はメッセージを表示
    if (StringUtils.toBool(sessionStorage.getItem("sessionTimeout"))) {
      this.errorMessage = Message.SESSION_TIMEOUT;
      sessionStorage.removeItem("sessionTimeout"); // 画面表示後はセッションから削除
    }

    // SPアプリからの遷移フラグの設定
    this.isSmartphoneAppMode = DisplayUtils.isSmartphoneAppMode();
  }

  /** PC版メニューにおける共通ID名称を返します。 */
  commonIdNameForPcMenu() {
    let name = this.commonIdName + "登録情報";
    if (name.length > 13) {
        return name.substring(0, 13) + "<br>" + name.substring(13, name.length);
    } else {
        return name;
    }
  }

  /** 共通ID情報メニューのクラス */
  get classMemberInfo() {
    return this.selectedPage === 'member-info' ? 'side-nav-selected-member' : 'side-nav-member';
  }

  /** PC用のメニューのクラス */
  getPcSideNavClass(pageName: SelectedPage) {
    return this.selectedPage === pageName ? 'side-nav-selected' : 'side-nav';
  }

  pageSelected(pageName: SelectedPage) {
    return this.selectedPage === pageName;
  }

  /** SP用のメニューのクラス */
  getSpSideNavClass(pageName: SelectedPage) {
    return this.selectedPage === pageName ? 'sp-title sp-btn' : 'sp-side-nav sp-btn';
  }

  closeUserInfoEdit() {
    this.errorMessage = ""; // エラーメッセージをクリア
  }

  closePasswordEdit() {
    this.errorMessage = ""; // エラーメッセージをクリア
  }

  closeCarInfoModal() {
    this.errorMessage = ""; // エラーメッセージをクリア
  }

  routeMoto() {
    // セッションストレージからredirectUrlを削除する前にGTMイベントを通知する
    GtmScript.noticeMyPageRedirectClick()

    sessionStorage.removeItem("redirectUrl");
    window.location.href = this.redirectUrl;
  }

  /** 共通ID情報を表示する */
  showMemberInfo() {
    this.selectedPage = 'member-info';
    scrollTo(0, 0);
  }

  /** お車情報を表示する */
  showCarInfo() {
    this.selectedPage = 'car-info-view';
    scrollTo(0, 0);
  }

  /** お客様番号を表示する */
  showCustomerCode() {
    this.selectedPage = 'customer-code-view';
    scrollTo(0, 0);
  }

  logout() {
    axios.get("/logout")
            .then(cb => {
              if (cb.data) {
                window.location.href = cb.data.toString();
              } else {
                // URLが指定されていない場合、エラー画面へ遷移
                this.$router.push("/client/error");
              }
            })
            .catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));
  }

  /**
   * 指定ページが存在する場合、値をそのまま返却。
   * 不正な遷移先の場合は、myPageTOPに遷移。
   * @param selectedPage
   */
  checkSelectedPage(selectedPage : string): string {
    if(pages.includes(selectedPage)) {
      return selectedPage;
    } else {
      // 指定されたページが存在しない場合
      return 'member-info';
    }
  }
}
